import React, { useEffect, useState } from 'react';
import { Col, Row, Table } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { api, endpoints } from '../../api';
import { routerPath } from '../../router/routerPath';
import {
  BlueLayout,
  CustomButton,
  CustomTableContainer,
  FormBlock,
  FormContainer,
  FormInput,
  PagesContainerUI,
} from '../../styles/styled';
import {
  PaginationType,
  PublishersTableType,
  PublishersType,
  PublisherTableType,
  PublisherType,
} from '../NewApplicationPage/types';

type PublisherPaginationType = PaginationType & {
  perPage: number;
};

export const PublisherPage = () => {
  const [paginationState, setPaginationState] = useState<PublisherPaginationType>({
    pagination: 1,
    amount: 0,
    perPage: 10,
  });
  const navigate = useNavigate();
  const [publishersState, setPublishersState] = useState<PublishersTableType>([]);
  const [searchState, setSearchState] = useState<string>('');

  const PublishersTableColumns = [
    {
      title: '№',
      dataIndex: 'id',
      key: 'id',
      render: (id: number, publisher: PublisherTableType) => <p>{publisher.key + 1}</p>,
    },
    {
      title: 'Наименование издательства',
      dataIndex: 'title',
      key: 'title',
      render: (value: string, publisher: PublisherType) => {
        return (
          <p className={publisher.is_archived ? 'dark' : 'text-link'}>
            <Link
              style={publisher.is_archived ? { color: 'black' } : {}}
              to={`${routerPath.editPublisher}${publisher.id}`}
            >
              {value} {publisher.is_archived && '(в архиве)'}
            </Link>
          </p>
        );
      },
    },
    {
      title: 'Адерс',
      dataIndex: 'address',
      key: 'address',
    },
    {
      title: 'Контакты',
      dataIndex: 'phone',
      key: 'phone',
      render: (value: string, publisher: PublisherTableType) => (
        <p style={{ minWidth: '100px' }}>
          {value ? value.split(',').join('; ') : '-'}
          <br />
          {publisher.email}
        </p>
      ),
    },
  ];

  useEffect(() => {
    (async () => {
      try {
        const response = await api.get<PublishersType>(endpoints.getPublishers(0, 1000));

        setPaginationState((prevState) => {
          return { ...prevState, amount: response.data.length };
        });

        const publishersData = response.data.filter((el) => !el.is_archived);

        setPublishersState(
          publishersData.map((el, index) => {
            return { ...el, key: index };
          }),
        );
      } catch (err) {}
    })();
  }, []);

  useEffect(() => {
    setPaginationState((prevState) => {
      return {
        ...prevState,
        amount:
          searchState.length > 0
            ? publishersState.filter((el) => el.title?.toLowerCase().includes(searchState.toLowerCase())).length
            : publishersState.length,
      };
    });
    // eslint-disable-next-line
  }, [searchState]);

  return (
    <PagesContainerUI>
      <BlueLayout>Издательства</BlueLayout>
      <FormBlock>
        <FormContainer>
          <Row gutter={[15, 20]}>
            <Col span={24}>
              <FormInput value={searchState} onChange={(e) => setSearchState(e.target.value)} placeholder="Найти" />
            </Col>
          </Row>
        </FormContainer>
      </FormBlock>

      <FormContainer>
        <div className="center">
          <CustomButton onClick={() => navigate(routerPath.newPublisher, { replace: true })} lined width="100%">
            Добавить издательство
          </CustomButton>
          <CustomButton onClick={() => setSearchState('')} lined>
            Очистить
          </CustomButton>
        </div>
      </FormContainer>

      <CustomTableContainer>
        <Table
          columns={PublishersTableColumns}
          pagination={{
            total: paginationState.amount,
            pageSize: paginationState.perPage,
            onChange: (value, pageSize) =>
              setPaginationState({ ...paginationState, pagination: value, perPage: pageSize }),
          }}
          dataSource={
            searchState.length > 0
              ? publishersState.filter((el) => el.title?.toLowerCase().includes(searchState.toLowerCase()))
              : publishersState
          }
          className={'table'}
        />
      </CustomTableContainer>
    </PagesContainerUI>
  );
};
